import { Headphones, PlayCircle } from "lucide-react";
import React from "react";

import { DeckCardType } from "../types";
import LibraryMusicIcon from "@mui/icons-material/LibraryMusic";
// import SingleCardBackgroundAnimation from "../component/animation/SingleCardBackgroundAnimation";
// import ListeningTogetherBackgroundAnimation from "../component/animation/ListeningTogetherBackgroundAnimation";
// import DemoCardBackgroundAnimation from "../component/animation/DemoCardBackgroundAnimation";

// ── Template string mapping ───────────────────────────────────────────────────

export const TEMPLATE_MAP: Record<DeckCardType, string> = {
  Single_Card: "Single Card Template",
  Demo_Card: "Demo Card Template",
  Listening_Together_Card: "Listening Together Card Template",
  Season_Card: "Season Card Template",
  Collection_Card: "Collection Card Template",
  Impact_Card: "Impact Card Template",
};

// ── Background animation map ──────────────────────────────────────────────────

// export const BG_ANIMATION: Record<DeckCardType, React.FC | null> = {
//   Single_Card: SingleCardBackgroundAnimation,
//   Demo_Card: DemoCardBackgroundAnimation,
//   Listening_Together_Card: ListeningTogetherBackgroundAnimation,
//   Season_Card: SingleCardBackgroundAnimation,
// };

// ── Grid column config per card type ─────────────────────────────────────────

export const GRID_COLS: Record<DeckCardType, object> = {
  Single_Card: {
    xs: "repeat(2, 1fr)",
    sm: "repeat(2, 1fr)",
    md: "repeat(auto-fill, minmax(240px, 280px))",
    lg: "repeat(auto-fill, minmax(240px, 280px))",
  },

  Demo_Card: {
    xs: "repeat(2, 1fr)",
    sm: "repeat(2, 1fr)",
    md: "repeat(auto-fill, minmax(240px, 280px))",
    lg: "repeat(auto-fill, minmax(240px, 280px))",
  },
  Listening_Together_Card: {
    xs: "repeat(2, 1fr)",
    sm: "repeat(2, 1fr)",
    md: "repeat(auto-fill, minmax(240px, 280px))",
    lg: "repeat(auto-fill, minmax(240px, 280px))",
  },
  Season_Card: {
    xs: "repeat(2, 1fr)",
    sm: "repeat(2, 1fr)",
    md: "repeat(auto-fill, minmax(240px, 280px))",
    lg: "repeat(auto-fill, minmax(240px, 280px))",
  },
  Collection_Card: {
    xs: "repeat(2, 1fr)",
    sm: "repeat(2, 1fr)",
    md: "repeat(auto-fill, minmax(240px, 280px))",
    lg: "repeat(auto-fill, minmax(240px, 280px))",
  },
  Impact_Card: {
    xs: "repeat(2, 1fr)",
    sm: "repeat(2, 1fr)",
    md: "repeat(auto-fill, minmax(240px, 280px))",
    lg: "repeat(auto-fill, minmax(240px, 280px))",
  },
};

// ── Icon and styling mapping for card types ───────────────────────────────────

export const CARD_TYPE_CONFIG: Record<
  DeckCardType,
  {
    icon: React.ReactNode;
    gradientLight: string;
    gradientDark: string;
    glowColor: string;
    iconColor: string;
  }
> = {
  Single_Card: {
    icon: <LibraryMusicIcon sx={{ fontSize: 38 }} />,
    gradientLight: "var(--taas-single-card-bg)",
    gradientDark: "var(--taas-single-card-bg-dark)",
    glowColor: "rgba(250,204,21,0.28)",
    iconColor: "#92400e",
  },
  Demo_Card: {
    icon: <PlayCircle size={38} />,
    gradientLight:
      "radial-gradient(circle at 50% 40%, #ffedd5 0%, #fed7aa 35%, #fdba74 65%, #f97316 100%)",
    gradientDark:
      "radial-gradient(circle at 50% 40%, #431407 0%, #2d1206 35%, #1c0a04 65%, #120603 100%)",
    glowColor: "rgba(249,115,22,0.32)",
    iconColor: "#f97316",
  },
  Listening_Together_Card: {
    icon: <Headphones size={38} />,
    gradientLight:
      "radial-gradient(circle at 50% 40%, #e0e7ff 0%, #c7d2fe 35%, #a5b4fc 65%, #6366f1 100%)",
    gradientDark:
      "radial-gradient(circle at 50% 40%, #1e1b4b 0%, #151238 35%, #0f0d2e 65%, #0a0820 100%)",
    glowColor: "rgba(99,102,241,0.32)",
    iconColor: "#6366f1",
  },
  Season_Card: {
    icon: <LibraryMusicIcon sx={{ fontSize: 38 }} />,
    gradientLight: "var(--taas-single-card-bg)",
    gradientDark: "var(--taas-single-card-bg-dark)",
    glowColor: "rgba(250,204,21,0.28)",
    iconColor: "#92400e",
  },
  Collection_Card: {
    icon: <LibraryMusicIcon sx={{ fontSize: 38 }} />,
    gradientLight: "var(--taas-single-card-bg)",
    gradientDark: "var(--taas-single-card-bg-dark)",
    glowColor: "rgba(250,204,21,0.28)",
    iconColor: "#92400e",
  },
  Impact_Card: {
    icon: <LibraryMusicIcon sx={{ fontSize: 38 }} />,
    gradientLight:
      "radial-gradient(circle at 50% 40%, #EEF5EF 0%, #DCEADF 35%, #A8C9B2 65%, #5E8F72 100%)",
    gradientDark:
      "radial-gradient(circle at 50% 40%, #203D33 0%, #162C24 35%, #102C24 65%, #0B1C17 100%)",
    glowColor: "rgba(94,143,114,0.32)",
    iconColor: "#5E8F72",
  },
};
